// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}
